import { ICalculatedProduct } from '../models/vouchers/calculateInstallment';

export interface IValidateCart {
	mobilePhone: string;
	commitment?: string;
	smartVoucherCommitmentId?: string;
	planAction: string;
	installmentAmount?: string;
}

export interface IValidateCartPayloadParams {
	mobilePhone: string;
	commitment?: string;
	smartVoucherCommitmentId?: string;
	calculatedProduct: ICalculatedProduct | undefined;
}

export type IPlanAction =
	| 'B2B_WITH_VOUCHER_UPFRONT'
	| 'B2B_WITH_VOUCHER_INSTALL'
	| 'B2B_WITHOUT_VOUCHER_UPFRONT'
	| 'B2B_WITHOUT_VOUCHER_INSTALL';

export interface IAddItemsToCartPayload {
	quantity: string;
	productId: string;
	xitem_mobilePhoneType?: string;
	xitem_mobilePhone?: string;
	xitem_planAction?: string;
	xitem_planCommitment?: string;
	xitem_provisioning?: string;
	xitem_oldTariff?: string;
	xitem_oldPlanCommitment?: string;
	xitem_oldProvisioning?: string;
	xitem_login?: string;
	xitem_productId?: string;
	xitem_oldDeviceCommitment?: string;
	installmentPeriod?: string;
	payment_plan?: string;
	productName?: string;
	xitem_installmentDuration?: string;
	xitem_commitmentDuration?: string;
	xitem_corporateNo?: string;
	xitem_accountNo?: string;
	xitem_bulk?: string;
	xitem_ebuPlanName?: string;
}

export function validateCartItems({
	mobilePhone,
	commitment,
	smartVoucherCommitmentId,
	planAction,
	installmentAmount,
}: IValidateCart): any {
	return {
		mobilePhone,
		commitment,
		smartVoucherCommitmentId,
		planAction,
		installmentAmount,
		xitem_bulk: true,
	};
}

export function getCartProducts(orderItem: IAddItemsToCartPayload[]): Record<string, any> {
	return {
		orderId: '.',
		x_calculateOrder: '1',
		orderItem,
		x_inventoryValidation: true,
	};
}

export const getValidateOfferPayload = ({
	mobilePhone,
	commitment,
	smartVoucherCommitmentId,
	calculatedProduct,
}: IValidateCartPayloadParams): IValidateCart => {
	return {
		mobilePhone,
		commitment,
		smartVoucherCommitmentId,
		planAction: Number(calculatedProduct?.device?.deviceCommitments?.installmentMonths)
			? 'B2B_WITH_VOUCHER_INSTALL'
			: 'B2B_WITH_VOUCHER_UPFRONT',
		installmentAmount: calculatedProduct?.device?.deviceCommitments?.installmentAmountBz || '0',
	};
};

export function deleteSingleCartItem(orderItemId: string): Record<string, any> {
	return {
		orderItemId,
		check: '0',
	};
}
